import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { ConfigurationService } from './configuration.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AverageWeeklyWagesService {

  private averageWeeklyWagesUrl: string = "/api/averageWeeklyWage/";
  constructor(private dataService: DataService, private configurationService: ConfigurationService, private http: HttpClient) {

    if (this.configurationService.isReady || this.configurationService.serverSettings != undefined)
      this.averageWeeklyWagesUrl = this.configurationService.serverSettings.policyClaimsAgentUrl + this.averageWeeklyWagesUrl;
    else
      this.configurationService.settingsLoaded$.subscribe(x => this.averageWeeklyWagesUrl = this.configurationService.serverSettings.policyClaimsAgentUrl + this.averageWeeklyWagesUrl);
  }

  getAverageWeeklyWages() {
    let Url = this.averageWeeklyWagesUrl + 'getAverageWeeklyWages';
    return this.dataService.get(Url);
  }

  addAverageWeeklyWage(data): any {
    return this.dataService.post(this.averageWeeklyWagesUrl, data);
  }

  updateAverageWeeklyWage(data): any {
    return this.dataService.putWithId(this.averageWeeklyWagesUrl, data);
  }

  deleteAverageWeeklyWage(data): any {
    let Url = this.averageWeeklyWagesUrl + 'deleteAverageWeeklyWage';
    return this.dataService.post(Url, data);
  }

}
